import api from "../api/axiosInstance";

const containerService = {
    getAll: (params) => api.get("/containers", { params }),
    create: (data) => api.post("/containers", data),
    update: (id, data) => api.patch(`/containers/${id}`, data),
    remove: (id) => api.delete(`/containers/${id}`),
    assignDockReceipts: (id, dockReceiptNumbers) =>
        api.patch(`/containers/${id}/dock-receipts`, { dockReceiptNumbers }),
    unassignDockReceipt: (id, dockReceiptNumber) =>
        api.patch(`/containers/${id}/dock-receipts/remove`, { dockReceiptNumber }),
    assignSailing: (id, sailingId) => api.patch(`/containers/${id}/sailing`, { sailingId }),
};

export default containerService;
